import { graphql } from "babel-plugin-relay/macro";
import React from "react";
import { createFragmentContainer } from "react-relay";
import { AuditionTextElement_element$data } from "../../__generated__/AuditionTextElement_element.graphql";
import { AuditionTextElement_screener$data } from "../../__generated__/AuditionTextElement_screener.graphql";
import { CommonElementProps } from "./Element";
import { ElementBase } from "./index";

type Props = {
  element: AuditionTextElement_element$data;
  screener: AuditionTextElement_screener$data;
} & CommonElementProps;
const AuditionTextElement: React.FC<Props> = props => <ElementBase {...props} />;

export default createFragmentContainer(AuditionTextElement, {
  element: graphql`
    fragment AuditionTextElement_element on ElementNode {
      ...ElementBase_element
    }
  `,
  screener: graphql`
    fragment AuditionTextElement_screener on ScreenerNode {
      ...ElementBase_screener
    }
  `,
});
